var exports = {
  "rQ": "bing-icon__dVKOaF",
  "VW": "headerContent__vlO9Pg",
  "Vz": "searchSummary__nDovc6",
  "nw": "resultCount__8zY6mx",
  "bB": "resultsList__z_hlWx",
  "IA": "resultCard__GQZd4V",
  "on": "resultLink__5AyqKy",
  "Vm": "resultUrl__frV5y8",
  "vi": "privacyNote__VgLNdx",
};

module.exports = exports;
